<template>

<div class="percentile">

	<div class="percentile-item" v-for="(bar, index) in bars" :key="index">
    
        <div class="percentile-item-bar" :style="bar.style" :class="{'is-active': index === value.index}" />
    
    </div>

</div>

</template>

<script>

export default {

	props: ['value'],

	computed: {

        bars: function() {

            var bars = []

            var max = this.$_.max(this.value.bins)

            this.$_.each(this.value.bins, function(count) {

                bars.push({
                    style: {
                        height: ((100 / max) * count).toString() + '%'
                    } 
                })

            })

            console.log(bars)

            return bars

        }

    }

}

</script>

<style scoped>

.percentile {
	display: flex;
	flex-direction: row-reverse;
	width: 100%;
	height: 48px;
	padding: 0px 10px;
	justify-content: center;
}

.percentile-item {
	width: calc(10% - 2px);
	border-radius: 4px;
	max-width: 10px;
	margin: 0px 1px;
	height: 36px;
	min-height: 4px;
    background-color: #eee;
}

.percentile-item-bar {
    background-color: #4881bb;
    position: absolute;
    left: 0px;
    width: 100%;
    bottom: 0px;
    border-radius: 4px;
}

.percentile-item-bar.is-active {
    background-color: #3bce5a;
}

</style>